import React from 'react';
import AppHeader from './AppHeader';
import { useShowcaseMode } from '../hooks/useShowcaseMode';

/**
 * Site chrome is the same AppHeader on every route.
 * Hidden only in car-show / iPad kiosk (`?display=1`, `?kiosk=1`, `?showcase=1`).
 */
const ConditionalAppHeader: React.FC = () => {
  const isShowcaseMode = useShowcaseMode();
  if (isShowcaseMode) return null;
  return <AppHeader />;
};

export default ConditionalAppHeader;
